module.exports = __webpack_public_path__ + "static/img/sjhz-title.aa051c9.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/xiayan/assets/img/sjhz-title.png
// module id = HG/z
// module chunks = 1